export const allStyles = /* GraphQL */ `
query GetStyles($input: inputGetAll) {
  getStyles(input: $input) {
        items {
            id
            title
            category {
            title
            }
            slug
            label
            description
            ibuMin
            ibuMax
            abvMin
            abvMax
            srmMin
            srmMax
            ogMin
            ogMax
            fgMin
            fgMax
        }
        nextToken
    }
}`
